import axios from 'axios';
import { Toast, Dialog } from 'vant';
import jsBridge from '@/utils/jsBridge';
import store from '@/store';
Toast.setDefaultOptions('loading', { forbidClick: true });

// accessToken过期
const ACCESS_TOKEN_INVALID = 10014;
// refreshToken过期
const REFRESH_TOKEN_INVALID = 10015;

let requestCount = 0;

const ps = sessionStorage.getItem('ps');
axios.defaults.timeout = 60 * 1000;
let v = store.state.appInfo.appVersion || "2.5.5";
const appToken = sessionStorage.getItem('token');

axios.interceptors.request.use((config) => {
  // if (appToken) {
  //   config.headers.Authorization = `Bearer ${appToken}`;
  // }
  config.headers.p = "H5";
  config.headers.v = v;
  let data = {}

  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  const currentToken = urlToken || sessionStorage.getItem('token') || appToken;

  if (currentToken) {
    config.headers.token = currentToken;
  }
  
  if (config.data) {
    data=typeof config.data === 'string'?JSON.parse(config.data):config.data
  }
  if (window.location.href.includes('ps=1') || ps) {
    config.headers.ps = 1
  }

  if (process.env.NODE_ENV === 'production') {
    const isClinic = window.sessionStorage.getItem('isClinic')
    if (!config.url.includes('-oss.yeahgo.com')) {
      if (isClinic) {
        config.url = `${process.env.VUE_APP_PHP_API_URL}${config.url}`;
      } else if(data.live){
        config.url = `${process.env.VUE_APP_JAVA_Live_API_URL}${config.url}`;
      } else{
        config.url = `${process.env.VUE_APP_JAVA_API_URL}${config.url}`;
      }
    }
  }
  return config;
}, (error) => Promise.reject(error));

/* eslint-disable */

axios.interceptors.response.use(
  response => {
    if (response.data) {
      return Promise.resolve(response.data);
    } else {
      return Promise.resolve({code:null,data:null,msg:response})
    }
}, error => {
  return Promise.reject(error)
})

/* eslint-enable */

const request = async ({
  url, method, data, options = {},
}) => {
  const { showLoading = true, showError = true, token} = options;
  if (showLoading && requestCount === 0) {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    });
  }

  if (showLoading) {
    requestCount += 1;
  }

  let params = 'data';

  if (method === 'get') {
    params = 'params';
  }

  let all = {
    url,
    method,
    [params]: {
      ...data,
      platform: 'web_app',
    },
  }
  const currentToken = token || sessionStorage.getItem('token');
  if (currentToken) {
    all.headers = {
      token: currentToken
    }
  }
  return axios(all).then((res) => {
    if (res.code === ACCESS_TOKEN_INVALID || res.code === REFRESH_TOKEN_INVALID || res.code === 10010) {
      if (store.state.appInfo.isApp) {
        jsBridge.callHandler('refreshToken',{})
        return
      }
      if (store.state.appInfo.isMiniprogram) {
        wx.miniProgram.navigateTo({
          url: '/pages/login/mobile/index'
        })
        return
      }
    }
    if (res.code !== 0 && showError) {
      setTimeout(() => {
        Dialog({ message: res.msg });
      }, 1000);
    }
    return res;
  }).catch((error) => {
    if (showError) {
      setTimeout(() => {
        if (error.message === 'timeout of 10000ms exceeded') {
          Toast({
            message: '网络请求超时',
          });
        } else {
          Toast({
            message: '网络请求失败',
          });
        }
      }, 1000);
    }
    return error;
  }).finally(() => {
    if (showLoading) {
      requestCount -= 1;
    }

    if (requestCount <= 0&&showLoading) {
      requestCount = 0;
      Toast.clear();
    }
  });
};

const get = ({ url, data = {}, options }) => request({
  url,
  method: 'get',
  data,
  options,
});

const post = ({ url, data = {}, options }) => request({
  url,
  method: 'post',
  data,
  options,
});

export default request;

export {
  get,
  post,
};
